export default "__VITE_ASSET__Dia9uwlr__"